import { lazy } from "react";

import { importRemote } from "@module-federation/utilities";
import { MicroFrontendLoader } from "@moodys/mdc-frontend.helpers.micro-frontend-loader";
import { getMFEBasePath } from "@moodys/mdc-shared-runtime";

import { LetterformSpinner, split } from "@moodys/federated";
import { ErrorPage } from "pages/ErrorPage/ErrorPage";
import { SPLIT_EMAIL_VIEWER } from "services/split/split.constants";

const EmailViewerRemote = lazy(() =>
  importRemote({
    url: getMFEBasePath({
      path: "mfe/notifications",
      staticStructure: true,
    }),
    scope: "MdcNotifications",
    module: "EmailViewer",
  })
);

export const EmailViewer = () => {
  return (
    <split.SplitWrapper
      loadingElement={<LetterformSpinner />}
      splitName={SPLIT_EMAIL_VIEWER}
      treatmentElementMap={{
        on: (
          <MicroFrontendLoader
            skeleton={<LetterformSpinner />}
            renderOnIntersect={false}
          >
            <EmailViewerRemote />
          </MicroFrontendLoader>
        ),
        off: <ErrorPage />,
        control: <ErrorPage />,
      }}
    />
  );
};
